import { takeEvery, all, put, select, call } from '@redux-saga/core/effects';
import { accountVerificationActions } from '../actions/accountVerification/accountVerification';
import actionTypes from '../actions/actionTypes';
import { userInfoBaseUrl, httpClient } from '../../http-client/http-client';
import { notificationActions } from '../actions/notifications/notifications';
import i18n from '../../i18n/i18n';
import { navigationActions } from '../actions/navigation/navigation';
import { getMenu } from '../../utils/menu';

const accessTokenSelector = (state) => state.oidc.user.access_token;
const userSelector = (state) => state.oidc.user;

function* fetchStatus(action) {
  const accessToken = yield select(accessTokenSelector);
  const url = `${userInfoBaseUrl}/accountverification`;
  try {
    const data = yield call(httpClient.get, url, accessToken);
    if(data.SubscriptionStatus.Exists) {
      yield put(navigationActions.getMenu());
    }
    yield put(accountVerificationActions.fetchStatusOk(data));
  }
  catch(error) {
    yield put(accountVerificationActions.fetchStatusError(error));
  }
}

function* sendVerificationEmail(action) {
  const accessToken = yield select(accessTokenSelector);
  const url = `${userInfoBaseUrl}/sendVerificationEmail`;

  try {
    yield call(httpClient.post, url, accessToken);
    yield put(accountVerificationActions.setVerificationEmailSent());
    yield put(notificationActions.enqueueSnackbar({
      message: i18n.t('resetPasswordRequestSent'), //'Verification email sent',
      options: {
        variant: 'success',
      },
      hasCloseButton: true
    }))
  }
  catch(error) {
    yield put(accountVerificationActions.sendVerificationEmailError(error));
  }
}

export function* calculateMenu(action) {
    const user = yield select(userSelector);
    const menu = yield call(getMenu, user);
    yield put(navigationActions.initMenu(menu));
}

function* emailVerified(action) {
  if(action.isVerified) {
    yield put(navigationActions.getMenu())
  }
}

export function* watchAccountVerification() {
  yield all([
    takeEvery(actionTypes.accountVerification.FETCH_STATUS, fetchStatus),
    takeEvery(actionTypes.accountVerification.SEND_VERIFICATION_EMAIL, sendVerificationEmail),
    takeEvery(actionTypes.accountVerification.EMAIL_VERIFIED, emailVerified),
    takeEvery(actionTypes.navigation.GET_MENU, calculateMenu)
  ]);
}